/* eslint-disable react/react-in-jsx-scope */

export const UserIcon = ({ width = 20, height = 20 }) => {
  return (
    <svg
      width={width}
      height={height}
      fill="currentColor"
      className="bi bi-person"
      viewBox="0 0 16 16"
    >
      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
    </svg>
  );
};
export const AddUserIcon = ({ width = 20, height = 20 }) => {
  return (
    <svg viewBox="0 0 24 24" width={width} height={height}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill="#b8c0c9"
        d="M14 14.252v2.09A6 6 0 0 0 6 22l-2-.001a8 8 0 0 1 10-7.748zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm6 6v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3z"
      />
    </svg>
  );
};
export const CallIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="3 3.19 17.81 17.81"
    >
      <path
        fill="#ffffff"
        d="m20.487 17.14-4.065-3.696a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1 1 0 0 0-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a.997.997 0 0 0-.085-1.39z"
      ></path>
    </svg>
  );
};
export const GalleryViewIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="#ffffff"
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M8.25 3H4.5A1.5 1.5 0 0 0 3 4.5v3.75a1.5 1.5 0 0 0 1.5 1.5h3.75a1.5 1.5 0 0 0 1.5-1.5V4.5A1.5 1.5 0 0 0 8.25 3ZM4.5 1.5a3 3 0 0 0-3 3v3.75a3 3 0 0 0 3 3h3.75a3 3 0 0 0 3-3V4.5a3 3 0 0 0-3-3H4.5ZM19.5 3h-3.75a1.5 1.5 0 0 0-1.5 1.5v3.75a1.5 1.5 0 0 0 1.5 1.5h3.75a1.5 1.5 0 0 0 1.5-1.5V4.5A1.5 1.5 0 0 0 19.5 3Zm-3.75-1.5a3 3 0 0 0-3 3v3.75a3 3 0 0 0 3 3h3.75a3 3 0 0 0 3-3V4.5a3 3 0 0 0-3-3h-3.75ZM8.25 14.25H4.5a1.5 1.5 0 0 0-1.5 1.5v3.75A1.5 1.5 0 0 0 4.5 21h3.75a1.5 1.5 0 0 0 1.5-1.5v-3.75a1.5 1.5 0 0 0-1.5-1.5Zm-3.75-1.5a3 3 0 0 0-3 3v3.75a3 3 0 0 0 3 3h3.75a3 3 0 0 0 3-3v-3.75a3 3 0 0 0-3-3H4.5ZM19.5 14.25h-3.75a1.5 1.5 0 0 0-1.5 1.5v3.75a1.5 1.5 0 0 0 1.5 1.5h3.75a1.5 1.5 0 0 0 1.5-1.5v-3.75a1.5 1.5 0 0 0-1.5-1.5Zm-3.75-1.5a3 3 0 0 0-3 3v3.75a3 3 0 0 0 3 3h3.75a3 3 0 0 0 3-3v-3.75a3 3 0 0 0-3-3h-3.75Z"
      ></path>
    </svg>
  );
};
export const ScreenShareIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="2 3 20 17"
    >
      <path
        fill="#ffffff"
        d="M20 17.722c.595-.347 1-.985 1-1.722V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v11c0 .736.405 1.375 1 1.722V18H2v2h20v-2h-2v-.278zM5 16V5h14l.002 11H5z"
      ></path>
    </svg>
  );
};
export const ForwardArrowIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="2.52 2.59 19.48 15.55"
    >
      <path
        fill="#ffffff"
        d="M11 6.914V2.586L6.293 7.293l-3.774 3.774 3.841 3.201L11 18.135V13.9c8.146-.614 11 4.1 11 4.1 0-2.937-.242-5.985-2.551-8.293C16.765 7.022 12.878 6.832 11 6.914z"
      ></path>
    </svg>
  );
};
export const RecordingIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="5 5 14 14"
    >
      <path
        fill="#ffffff"
        d="M12 5c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7zm0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
      ></path>
      <path
        fill="#ffffff"
        d="M12 9c-1.627 0-3 1.373-3 3s1.373 3 3 3 3-1.373 3-3-1.373-3-3-3z"
      ></path>
    </svg>
  );
};
export const RecordLoadingIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      version="1.1"
      id="L9"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      className={className}
      width={width}
      height={height}
    >
      <path
        width="100%"
        height="100%"
        fill="#fff"
        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="1s"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"
        />
      </path>
      <circle
        cx="50"
        cy="50"
        r="10"
        stroke="white"
        strokeWidth="3"
        fill="white"
      />
    </svg>
  );
};
export const ShareIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="2 4 20 16"
    >
      <path fill="#ffffff" d="M11 15h2V9h3l-4-5-4 5h3z"></path>
      <path
        fill="#ffffff"
        d="M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
      ></path>
    </svg>
  );
};
export const SpeakerIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        fill="#ffffff"
        d="M16 21c3.527-1.547 5.999-4.909 5.999-9S19.527 4.547 16 3v2c2.387 1.386 3.999 4.047 3.999 7S18.387 17.614 16 19v2z"
      ></path>
      <path
        fill="#ffffff"
        d="M16 7v10c1.225-1.1 2-3.229 2-5s-.775-3.9-2-5zM4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20V4a1 1 0 0 0-1.554-.832L6.697 7H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h3c.033 0 .061-.016.093-.019a1.027 1.027 0 0 0 .38-.116c.026-.015.057-.017.082-.033L12 5.868v12.264l-4.445-2.964c-.025-.017-.056-.02-.082-.033a.986.986 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9z"
      ></path>
    </svg>
  );
};
export const SpeakerSlashIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        fill="#ffffff"
        d="m21.707 20.293-2.023-2.023A9.566 9.566 0 0 0 21.999 12c0-4.091-2.472-7.453-5.999-9v2c2.387 1.386 3.999 4.047 3.999 7a8.113 8.113 0 0 1-1.672 4.913l-1.285-1.285C17.644 14.536 18 13.19 18 12c0-1.771-.775-3.9-2-5v7.586l-2-2V4a1 1 0 0 0-1.554-.832L7.727 6.313l-4.02-4.02-1.414 1.414 18 18 1.414-1.414zM12 5.868v4.718L9.169 7.755 12 5.868zM4 17h2.697l5.748 3.832a1.004 1.004 0 0 0 1.027.05A1 1 0 0 0 14 20v-1.879l-2-2v2.011l-4.445-2.964c-.025-.017-.056-.02-.082-.033a.986.986 0 0 0-.382-.116C7.059 15.016 7.032 15 7 15H4V9h.879L3.102 7.223A1.995 1.995 0 0 0 2 9v6c0 1.103.897 2 2 2z"
      ></path>
    </svg>
  );
};
export const VideoSlashIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="2 2.29 20 19.41"
    >
      <path
        fill="#ffffff"
        d="M18 7c0-1.103-.897-2-2-2H6.414L3.707 2.293 2.293 3.707l18 18 1.414-1.414L18 16.586v-2.919L22 17V7l-4 3.333V7zm-2 7.586L8.414 7H16v7.586zM4 19h10.879l-2-2H4V8.121L2.145 6.265A1.977 1.977 0 0 0 2 7v10c0 1.103.897 2 2 2z"
      ></path>
    </svg>
  );
};
export const VideoIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="2 5 20 14"
    >
      <path
        fill="#ffffff"
        d="M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7zm-1.998 10H4V7h12l.001 4.999L16 12l.001.001.001 4.999z"
      ></path>
    </svg>
  );
};
export const UnMuteIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="2.29 2 19.41 20.02"
    >
      <path
        fill="#ffffff"
        d="m21.707 20.293-3.388-3.388A7.942 7.942 0 0 0 20 12.021h-2a5.95 5.95 0 0 1-1.109 3.456l-1.452-1.452c.348-.591.561-1.27.561-2.004v-6C16 3.804 14.215 2 12.021 2c-.07 0-.14.009-.209.025A4.005 4.005 0 0 0 8 6.021v.565L3.707 2.293 2.293 3.707l18 18 1.414-1.414zM10 6.021c0-1.103.897-2 2-2a.918.918 0 0 0 .164-.015C13.188 4.08 14 4.956 14 6.021v6c0 .172-.029.335-.071.494L10 8.586V6.021zm-4 6H4c0 4.072 3.06 7.436 7 7.931v2.069h2v-2.07a7.993 7.993 0 0 0 2.218-.611l-1.558-1.558a5.979 5.979 0 0 1-1.66.239c-3.309 0-6-2.692-6-6z"
      ></path>
      <path
        fill="#ffffff"
        d="M8.011 12.132a3.993 3.993 0 0 0 3.877 3.877l-3.877-3.877z"
      ></path>
    </svg>
  );
};
export const MuteIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="4 1.98 16 20.02"
    >
      <path
        fill="#ffffff"
        d="M16 12V6c0-2.217-1.785-4.021-3.979-4.021a.933.933 0 0 0-.209.025A4.006 4.006 0 0 0 8 6v6c0 2.206 1.794 4 4 4s4-1.794 4-4zm-6 0V6c0-1.103.897-2 2-2a.89.89 0 0 0 .163-.015C13.188 4.06 14 4.935 14 6v6c0 1.103-.897 2-2 2s-2-.897-2-2z"
      ></path>
      <path
        fill="#ffffff"
        d="M6 12H4c0 4.072 3.061 7.436 7 7.931V22h2v-2.069c3.939-.495 7-3.858 7-7.931h-2c0 3.309-2.691 6-6 6s-6-2.691-6-6z"
      ></path>
    </svg>
  );
};
export const FillHandIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      fill="none"
      className={className}
      width={width}
      height={height}
      viewBox="5.65 2.5 46.85 55"
    >
      <path
        d="M35 8.75V27.5V11.25C35 9.17893 36.679 7.5 38.75 7.5C40.821 7.5 42.5 9.17893 42.5 11.25V27.5V18.75C42.5 16.6789 44.179 15 46.25 15C48.321 15 50 16.6789 50 18.75V40C50 48.2842 43.2842 55 35 55H32.1817C28.3707 55 24.7028 53.5495 21.9226 50.943L9.52612 39.3213C7.73412 37.6413 7.6885 34.8115 9.4254 33.0745C11.1235 31.3765 13.8766 31.3765 15.5746 33.0745L20 37.5V16.25C20 14.1789 21.6789 12.5 23.75 12.5C25.821 12.5 27.5 14.1789 27.5 16.25V27.5V8.75C27.5 6.67893 29.179 5 31.25 5C33.321 5 35 6.67893 35 8.75Z"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};
export const RaiseHandIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      fill="none"
      viewBox="7.65 4.5 42.85 51"
      className={className}
      width={width}
      height={height}
    >
      <path
        d="M35 8.75V27.5V11.25C35 9.17893 36.679 7.5 38.75 7.5C40.821 7.5 42.5 9.17893 42.5 11.25V27.5V18.75C42.5 16.6789 44.179 15 46.25 15C48.321 15 50 16.6789 50 18.75V40C50 48.2842 43.2842 55 35 55H32.1817C28.3707 55 24.7028 53.5495 21.9226 50.943L9.52612 39.3213C7.73412 37.6413 7.6885 34.8115 9.4254 33.0745C11.1235 31.3765 13.8766 31.3765 15.5746 33.0745L20 37.5V16.25C20 14.1789 21.6789 12.5 23.75 12.5C25.821 12.5 27.5 14.1789 27.5 16.25V27.5V8.75C27.5 6.67893 29.179 5 31.25 5C33.321 5 35 6.67893 35 8.75Z"
        fill="#FFFFFF"
        stroke="grey"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};
export const PauseIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg className={className} width={width} height={height} viewBox="8 7 8 10">
      <path fill="#b8c0c9" d="M8 7h3v10H8zm5 0h3v10h-3z" />
    </svg>
  );
};
export const PlayIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="7 6 10 12"
    >
      <path fill="#b8c0c9" d="M7 6v12l10-6z" />
    </svg>
  );
};
export const MessageFillIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9 9 0 0 0 8 15" />
    </svg>
  );
};
export const MessageIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M2.678 11.894a1 1 0 0 1 .287.801 11 11 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8 8 0 0 0 8 14c3.996 0 7-2.807 7-6s-3.004-6-7-6-7 2.808-7 6c0 1.468.617 2.83 1.678 3.894m-.493 3.905a22 22 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a10 10 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105" />
    </svg>
  );
};
export const MessageDetailIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M7 9h10v2H7zm0 4h7v2H7z"></path>
      <path d="M12 2C6.49 2 2 6.49 2 12c0 2.12.68 4.19 1.93 5.9l-1.75 2.53c-.21.31-.24.7-.06 1.03.17.33.51.54.89.54h9c5.51 0 10-4.49 10-10S17.51 2 12 2m0 18H4.91L6 18.43c.26-.37.23-.88-.06-1.22A7.98 7.98 0 0 1 4.01 12c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8Z"></path>
    </svg>
  );
};
export const PinFillIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path
        fill="currentColor"
        d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a6 6 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707s.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a6 6 0 0 1 1.013.16l3.134-3.133a3 3 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146"
      />
    </svg>
  );
};
export const PinIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a6 6 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707s.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a6 6 0 0 1 1.013.16l3.134-3.133a3 3 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146m.122 2.112v-.002zm0-.002v.002a.5.5 0 0 1-.122.51L6.293 6.878a.5.5 0 0 1-.511.12H5.78l-.014-.004a5 5 0 0 0-.288-.076 5 5 0 0 0-.765-.116c-.422-.028-.836.008-1.175.15l5.51 5.509c.141-.34.177-.753.149-1.175a5 5 0 0 0-.192-1.054l-.004-.013v-.001a.5.5 0 0 1 .12-.512l3.536-3.535a.5.5 0 0 1 .532-.115l.096.022c.087.017.208.034.344.034q.172.002.343-.04L9.927 2.028q-.042.172-.04.343a1.8 1.8 0 0 0 .062.46z" />
    </svg>
  );
};
export const FilesFillIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M7.765 1.559a.5.5 0 0 1 .47 0l7.5 4a.5.5 0 0 1 0 .882l-7.5 4a.5.5 0 0 1-.47 0l-7.5-4a.5.5 0 0 1 0-.882z" />
      <path d="m2.125 8.567-1.86.992a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882l-1.86-.992-5.17 2.756a1.5 1.5 0 0 1-1.41 0z" />
    </svg>
  );
};
export const FilesIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M8.235 1.559a.5.5 0 0 0-.47 0l-7.5 4a.5.5 0 0 0 0 .882L3.188 8 .264 9.559a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882L12.813 8l2.922-1.559a.5.5 0 0 0 0-.882zm3.515 7.008L14.438 10 8 13.433 1.562 10 4.25 8.567l3.515 1.874a.5.5 0 0 0 .47 0zM8 9.433 1.562 6 8 2.567 14.438 6z" />
    </svg>
  );
};
export const SearchIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
    </svg>
  );
};
export const XIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="2240.448 1762.444 15.556 15.556"
    >
      <path
        d="m2250.727 1766.055-2.5 2.5-2.5-2.5a.786.786 0 0 0-1.112 0l-.555.556a.786.786 0 0 0 0 1.11l2.5 2.5-2.5 2.501a.786.786 0 0 0 0 1.111l.555.556a.786.786 0 0 0 1.111 0l2.5-2.5 2.5 2.5a.786.786 0 0 0 1.112 0l.555-.556a.786.786 0 0 0 0-1.11l-2.5-2.501 2.5-2.5a.786.786 0 0 0 0-1.111l-.555-.556a.786.786 0 0 0-1.111 0Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};
export const DownChevronIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="6.29 9.29 11.41 7.12"
    >
      <path d="M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z"></path>
    </svg>
  );
};
export const EmojiIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="2 2 20 20"
    >
      <path
        fill="#b8c0c9"
        d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
      ></path>
      <path
        fill="#b8c0c9"
        d="M14.829 14.828a4.055 4.055 0 0 1-1.272.858 4.002 4.002 0 0 1-4.875-1.45l-1.658 1.119a6.063 6.063 0 0 0 1.621 1.62 5.963 5.963 0 0 0 2.148.903 6.042 6.042 0 0 0 2.415 0 5.972 5.972 0 0 0 2.148-.903c.313-.212.612-.458.886-.731.272-.271.52-.571.734-.889l-1.658-1.119a4.017 4.017 0 0 1-.489.592z"
      ></path>
      <circle fill="#b8c0c9" cx="8.5" cy="10.5" r="1.5"></circle>
      <circle fill="#b8c0c9" cx="15.493" cy="10.493" r="1.493"></circle>
    </svg>
  );
};
export const LockIcon = ({ width = 20, height = 20, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M6 22h12c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2h-1V7c0-2.76-2.24-5-5-5S7 4.24 7 7v2H6c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2M9 7c0-1.65 1.35-3 3-3s3 1.35 3 3v2H9z"></path>
    </svg>
  );
};
